export default __webpack_public_path__ + "static/media/template14.c2275ea1.svg";